// extracted by mini-css-extract-plugin
export default {"skeletonWrap":"Loading_skeletonWrap__26tnw","portfolio":"Loading_portfolio__48VKz","resume":"Loading_resume__A4pcg"};